if (!customElements.get('glassify-product-information')) {
  customElements.define('glassify-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.setupFrameInquiry();
      if (!this.eventsBound) {
        this.eventsBound = true;
        (this.closest('product-page') || this).addEventListener('click', event => {
          const opener = event.target.closest('[data-gpi-open]');
          const tab = event.target.closest('[data-gpi-tab]');
          if (opener) {
            this.origin = opener;
            this.select(opener.dataset.gpiOpen);
            this.dialog.showModal();
            opener.setAttribute('aria-expanded', 'true');
            this.querySelector('[data-gpi-close]').focus();
          } else if (tab) this.select(tab.dataset.gpiTab);
          else if (event.target.closest('[data-gpi-close]')) this.dialog.close();
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.querySelectorAll('[data-gpi-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
          this.origin?.setAttribute('aria-expanded', 'false');
          this.origin?.focus();
        });
      }
      this.closest('product-page')?.classList.add('gpi-summary-enabled');
      if (this.classList.contains('gpi--exchange')) this.buildSummary();
      else this.buildFrameSummary();
    }

    setupFrameInquiry() {
      const template = this.querySelector('[data-gpi-frame-template]');
      if (!template || this.frameDialog) return;
      this.frameDialog = template.content.querySelector('dialog').cloneNode(true);
      document.body.append(this.frameDialog);
      const dialog = this.frameDialog;
      const form = dialog.querySelector('form');
      const photo = form.querySelector('[data-gpi-frame-photo]');
      const preview = form.querySelector('[data-gpi-frame-preview]');
      const status = form.querySelector('[data-gpi-frame-status]');
      const submit = form.querySelector('[type=submit]');
      const setStatus = (message, error = false) => {
        status.textContent = message;
        status.toggleAttribute('data-error', error);
      };
      this.frameOpenHandler = event => {
        this.frameOrigin = event.currentTarget;
        dialog.showModal();
        dialog.querySelector('[data-gpi-frame-close]').focus();
      };
      this.frameOpener = this.querySelector('[data-gpi-frame-open]');
      const frameLocation = document.querySelector('[data-gpi-frame-location]');
      if (frameLocation) frameLocation.append(this.frameOpener);
      this.frameOpener.addEventListener('click', this.frameOpenHandler);
      dialog.querySelector('[data-gpi-frame-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => this.frameOrigin?.focus());
      photo.addEventListener('change', () => {
        this.frameUploaded = null;
        form.querySelector('[data-gpi-frame-url]').value = '';
        photo.setCustomValidity('');
        if (this.framePreviewURL) URL.revokeObjectURL(this.framePreviewURL);
        preview.hidden = true;
        preview.removeAttribute('src');
        setStatus('');
        const file = photo.files[0];
        if (!file) return;
        if (!/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name) || (file.type && !/^image\//.test(file.type))) {
          photo.setCustomValidity('Vælg et billede i JPG-, PNG-, WebP- eller HEIC-format.');
          setStatus(photo.validationMessage, true);
          return;
        }
        if (file.size > 10 * 1024 * 1024 || file.size === 0) {
          photo.setCustomValidity('Billedet skal være mindre end 10 MB og må ikke være tomt.');
          setStatus(photo.validationMessage, true);
          return;
        }
        this.framePreviewURL = URL.createObjectURL(file);
        preview.src = this.framePreviewURL;
        preview.hidden = false;
        preview.onerror = () => { preview.hidden = true; };
      });
      form.addEventListener('submit', async event => {
        if (this.frameAllowSubmit) return;
        event.preventDefault();
        if (this.frameSending || !form.reportValidity()) return;
        const file = photo.files[0];
        if (!file) return;
        this.frameSending = true;
        submit.disabled = true;
        photo.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
          setStatus('Uploader dit billede …');
          if (!this.frameUploaded || this.frameUploaded.file !== file) {
            const url = await this.uploadFramePhoto(file);
            this.frameUploaded = { file, url };
          }
          form.querySelector('[data-gpi-frame-url]').value = this.frameUploaded.url;
          form.querySelector('[data-gpi-frame-body]').value = 'Kan I skifte glassene i mit stel?\n\nBillede af stel: ' + this.frameUploaded.url + '\nProdukt: ' + form.querySelector('[name="contact[Produkt]"]').value + '\nProduktside: ' + form.querySelector('[name="contact[Produktside]"]').value;
          this.frameAllowSubmit = true;
          submit.disabled = false;
          photo.disabled = false;
          setStatus('Billedet er uploadet. Sender din forespørgsel …');
          form.requestSubmit(submit);
        } catch (error) {
          setStatus('Billedet kunne ikke uploades. Prøv igen, eller send billedet til info@glassify.dk.', true);
          submit.disabled = false;
          photo.disabled = false;
          this.frameSending = false;
          form.removeAttribute('aria-busy');
        }
      });
      if (dialog.querySelector('.gpi__frame-success, .gpi__frame-error')) dialog.showModal();
    }

    async uploadFramePhoto(file) {
      const script = [...document.scripts].find(item => item.src.includes('d1liekpayvooaz.cloudfront.net/apps/uploadery/uploadery.js'));
      if (!script) throw new Error('Uploadery is unavailable');
      const response = await fetch(script.src, { credentials: 'omit', signal: AbortSignal.timeout(30000) });
      if (!response.ok) throw new Error('Uploadery configuration failed');
      const source = await response.text();
      const match = source.match(/var ShoppadUploaderyConfig\s*=\s*({[^\n]+?});/);
      if (!match) throw new Error('Uploadery configuration is unavailable');
      const config = JSON.parse(match[1]);
      const endpoint = new URL(config.signature_path, location.href);
      if (endpoint.hostname !== 'www.theshoppad.com' || endpoint.pathname !== '/apps/uploadery/client/sign.json' || !/^[a-z0-9-]+$/i.test(config.uuid)) throw new Error('Invalid upload configuration');
      endpoint.protocol = 'https:';
      const signedResponse = await fetch(endpoint.href, {
        method: 'POST', credentials: 'omit', signal: AbortSignal.timeout(30000),
        body: new URLSearchParams({ name: file.name, token: config.signature_token, uuid: config.uuid })
      });
      if (!signedResponse.ok) throw new Error('Upload authorization failed');
      const signed = await signedResponse.json();
      if (!['key', 'accesskey', 'policy', 'signature'].every(key => typeof signed[key] === 'string' && signed[key])) throw new Error('Invalid upload authorization');
      const key = config.uuid + '/' + signed.key;
      const data = new FormData();
      data.append('key', key);
      data.append('AWSAccessKeyId', signed.accesskey);
      data.append('acl', 'public-read');
      data.append('success_action_status', '200');
      data.append('policy', signed.policy);
      data.append('signature', signed.signature);
      data.append('Content-Type', 'binary/octet-stream');
      data.append('file', file);
      const uploaded = await fetch('https://uploadery.s3.amazonaws.com/', { method: 'POST', body: data, signal: AbortSignal.timeout(60000) });
      if (!uploaded.ok) throw new Error('Image upload failed');
      return 'https://uploadery.s3.theshoppad.net/' + key.split('/').map(encodeURIComponent).join('/');
    }

    updateSummarySavings(box, price, compare) {
      const amount = node => Number((node?.textContent || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'));
      const difference = Math.round((amount(compare) - amount(price)) * 100) / 100;
      const hasSaving = !!price?.textContent.trim() && Number.isFinite(difference) && difference > 0;
      const original = box.querySelector('[data-gpi-original-total]');
      if (original) {
        original.textContent = hasSaving ? compare.textContent : '';
        original.hidden = !hasSaving;
      }
      const saving = box.querySelector('[data-gpi-total-saving]');
      if (saving) {
        saving.hidden = !hasSaving;
        saving.textContent = hasSaving ? 'Spar i alt ' + new Intl.NumberFormat('da-DK', { maximumFractionDigits: 2 }).format(difference) + ' kr.' : '';
      }
    }

    buildFrameSummary() {
      const area = this.closest('.product-text');
      const box = area?.querySelector('.prices-combined-container');
      const title = area?.querySelector('.product__title');
      const frame = box?.querySelector('.product-price-container');
      const total = area?.querySelector('.add-to-cart-price');
      if (!box || !title || !frame || !total) return;
      const current = box.querySelector('[data-gpi-current-price]');
      const totalDisplay = box.querySelector('[data-gpi-frame-total]');
      const totalCompare = area.querySelector('#add-to-cart-button .gpi-atc-compare');
      this.updateFrameDisplay = () => {
        current.textContent = total.textContent;
        if (totalDisplay && totalDisplay.textContent !== total.textContent) totalDisplay.textContent = total.textContent;
        this.updateSummarySavings(box, total, totalCompare);
      };
      this.frameObserver?.disconnect();
      this.frameObserver = new MutationObserver(this.updateFrameDisplay);
      [total, totalCompare].filter(Boolean).forEach(element => this.frameObserver.observe(element, { childList: true, characterData: true, subtree: true }));
      this.updateFrameDisplay();
      this.fitFrameTitle = () => {
        title.style.removeProperty('--gpi-frame-title-size');
        const model = title.querySelector('.gpi-frame-model');
        const available = title.clientWidth;
        const needed = model.getBoundingClientRect().width;
        const size = parseFloat(getComputedStyle(title).fontSize);
        if (needed > available && available > 0) title.style.setProperty('--gpi-frame-title-size', `${Math.max(11, Math.floor(size * available / needed * 10) / 10)}px`);
      };
      this.titleObserver?.disconnect();
      this.titleObserver = new ResizeObserver(this.fitFrameTitle);
      this.titleObserver.observe(title);
      this.titleObserver.observe(box);
      document.fonts.ready.then(() => { if (this.isConnected) this.fitFrameTitle(); });
      this.fitFrameTitle();
    }

    buildSummary() {
      const area = this.closest('.product-text');
      const box = area?.querySelector('.gpi-exchange-pricebox');
      const title = area?.querySelector('.gpi-exchange-title');
      const price = box?.querySelector('.product-price-container');
      const comparison = box?.querySelector('.gpi-desktop-comparison');
      if (!box || !title || !price || !comparison) return;
      const original = price.querySelector('.product-price--original');
      const compare = price.querySelector('.product-price--compare');
      const current = comparison.querySelector('[data-gpi-current-price]');
      this.updateDisplayedPrice = () => {
        if (original && current) current.textContent = original.textContent;
        this.updateSummarySavings(box, original, compare);
        this.updateSelectionSummary();
      };
      this.priceObserver?.disconnect();
      this.priceObserver = new MutationObserver(this.updateDisplayedPrice);
      [original, compare].filter(Boolean).forEach(node => this.priceObserver.observe(node, { childList: true, characterData: true, subtree: true }));
      this.updateDisplayedPrice();
      if (!this.selectionChangeHandler) {
        this.selectionArea = area;
        this.selectionChangeHandler = () => this.updateSelectionSummary();
        area.addEventListener('change', this.selectionChangeHandler);
      }
      this.fitTitle = () => {
        const text = title.querySelector('.gpi-title-desktop');
        if (!text) return;
        title.style.removeProperty('--gpi-summary-title-size');
        if (window.matchMedia('(max-width: 767px)').matches) return;
        const available = title.clientWidth;
        const needed = text.getBoundingClientRect().width;
        const size = parseFloat(getComputedStyle(title).fontSize);
        if (needed > available && available > 0) {
          title.style.setProperty('--gpi-summary-title-size', `${Math.max(11, Math.floor(size * available / needed * 10) / 10)}px`);
        }
      };
      this.titleObserver?.disconnect();
      this.titleObserver = new ResizeObserver(this.fitTitle);
      this.titleObserver.observe(box);
      this.titleObserver.observe(title);
      document.fonts.ready.then(() => { if (this.isConnected) this.fitTitle(); });
      this.fitTitle();
    }

    updateSelectionSummary() {
      const area = this.closest('.product-text');
      const summaries = area?.querySelectorAll('[data-gpi-selection-summary]');
      if (!summaries?.length) return;
      const selected = name => area.querySelector('input[name="' + name + '"]:checked');
      const label = input => (input?.dataset.variantTitle || '').trim();
      const parts = [];
      const quality = label(selected('progressive-lenses'));
      if (quality) parts.push(quality + ' flerstyrkeglas');
      const coating = label(selected('glass-coating'));
      if (coating) {
        const layers = coating.match(/(\d+)\s*[-–]?\s*lags?/i);
        parts.push(layers ? layers[1] + '-lags coating' : coating.replace(/\b(sølv|guld|diamant)\b\s*/gi, '').trim());
      }
      const thickness = label(selected('glass-thickness'));
      const index = thickness.match(/1[.,](?:74|67|6|5)\b/);
      if (index && index[0].replace(',', '.') !== '1.5') {
        const name = thickness.replace(/\s*\([^)]*\)/g, '').trim().toLowerCase();
        parts.push(name + ' glas (' + index[0].replace('.', ',') + ')');
      }
      const extra = selected('extras');
      if (extra && extra.id !== 'extras-one') {
        let extraName = label(extra);
        if (extra.id === 'extras-three') {
          const type = selected('sunglasses-type');
          extraName = label(type) || extraName;
          const color = area.querySelector('.sunglasses-type-input:not(.hidden) input:checked')?.getAttribute('variant_name');
          if (color) extraName += ' (' + color.toLowerCase() + ')';
        } else if (extra.id === 'extras-four') {
          const color = area.querySelector('.transition-input-list input:checked')?.getAttribute('variant_name');
          if (color) extraName += ' (' + color.toLowerCase() + ')';
        }
        if (extraName) parts.push(extraName.replace(/™/g, ''));
      }
      const text = 'Inkl. ' + (parts.length ? parts.join(', ') + ', ' : '') + 'montering & fragt.';
      summaries.forEach(summary => {
        const content = summary.classList.contains('gpi-summary-included-mobile') ? '2 glas · ' + text : text;
        if (summary.textContent !== content) summary.textContent = content;
      });
    }

    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.priceObserver?.disconnect();
        this.frameObserver?.disconnect();
        this.titleObserver?.disconnect();
        this.selectionArea?.removeEventListener('change', this.selectionChangeHandler);
        this.selectionChangeHandler = null;
        this.frameDialog?.remove();
        this.frameDialog = null;
        this.frameOpener?.removeEventListener('click', this.frameOpenHandler);
        if (this.frameOpener && !this.contains(this.frameOpener)) this.append(this.frameOpener);
        if (this.framePreviewURL) URL.revokeObjectURL(this.framePreviewURL);
        this.ready = false;
      });
    }

    select(key) {
      this.querySelectorAll('[data-gpi-tab]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gpiTab === key)));
      this.querySelectorAll('[data-gpi-panel]').forEach(panel => { panel.hidden = panel.dataset.gpiPanel !== key; });
    }
  });
}

// Preserve Anyday's live instalment count and modal; only adapt its payment-row layout.
if(!customElements.get('glassify-payment-row')){
  customElements.define('glassify-payment-row',class extends HTMLElement{
    connectedCallback(){
      this.cancelled=false;
      customElements.whenDefined('anyday-price-widget').then(()=>this.connectWidget());
    }
    disconnectedCallback(){this.cancelled=true;clearTimeout(this.retry);this.observer?.disconnect();}
    connectWidget(attempt=0){
      if(this.cancelled)return;
      const widget=this.querySelector('anyday-price-widget'),root=widget?.shadowRoot;
      if(!root){if(attempt<50)this.retry=setTimeout(()=>this.connectWidget(attempt+1),100);return;}
      const update=()=>{
        if(!root.querySelector('[data-glassify-layout]')){
          const style=document.createElement('style');style.dataset.glassifyLayout='';
          style.textContent=':host{font-size:14px!important}.anyday-widget-container{flex-direction:row!important;flex-wrap:nowrap!important;gap:6px!important}.anyday-logo{order:-1;flex-shrink:0}.anyday-header{font-size:.9em!important;white-space:nowrap;margin:0!important}@media(max-width:767px){:host{font-size:12px!important}}';
          root.append(style);
        }
        const heading=root.querySelector('.anyday-header');
        if(heading){const clean=heading.textContent.replace(/\s+(med|with)\s*$/i,'');if(clean!==heading.textContent)heading.textContent=clean;}
      };
      update();this.observer=new MutationObserver(update);this.observer.observe(root,{childList:true,subtree:true,characterData:true});
    }
  });
}
